if (
  ($(document).ready(function () {
    document.all &&
      $("#Menu li.HasSubMenu").hover(
        function () {
          return $(this).addClass("over"), !1;
        },
        function () {
          $(this).removeClass("over");
        }
      );
  }),
  "undefined" == typeof ISSelectReplacement)
) {
  var ISSelectReplacement = {
    init: function () {
      window.addEventListener
        ? window.addEventListener("load", ISSelectReplacement.on_load, !1)
        : window.attachEvent("onload", ISSelectReplacement.on_load);
    },
    on_load: function () {
      var a = document.getElementsByTagName("SELECT");
      if (!a) return !1;
      for (var b = 0; b < a.length; b++) {
        var c = a[b];
        c.multiple &&
          -1 != c.className.indexOf("ISSelectReplacement") &&
          -1 == c.className.indexOf("ISSelectAlreadyReplaced") &&
          -1 == c.className.indexOf("ISSelectReplacementDeferred") &&
          ISSelectReplacement.replace_select(a[b]);
      }
    },
    replace_select: function (a) {
      a.name;
      a.style.visibility = "hidden";
      var b = document.createElement("DIV");
      (b.className = "ISSelect " + a.className),
        (b.className += " ISSelectAlreadyReplaced");
      var c = !1;
      if (0 == a.offsetHeight) {
        var d = a.cloneNode(!0);
        if (
          ((d.style.position = "absolute"),
          (d.style.left = "-10000px"),
          (d.style.top = "-10000px"),
          (d.style.display = "block"),
          document.body.appendChild(d),
          (offset_height = d.offsetHeight + "px"),
          (offset_width = d.offsetWidth + "px"),
          d.parentNode.removeChild(d),
          a.style.display && "none" == a.style.display)
        )
          var c = !0;
      } else
        (offset_height = a.offsetHeight + "px"),
          (offset_width = a.offsetWidth + "px");
      var e = ISSelectReplacement.get_prop(a, "width");
      e && "auto" != e && (offset_width = e);
      var f = ISSelectReplacement.get_prop(a, "height");
      f && "auto" != f && (offset_height = f),
        (b.style.height = offset_height),
        parseInt(offset_width) < 200 && (offset_width = "200px"),
        (b.style.width = offset_width),
        a.id && ((b.id = a.id), (a.id += "_old")),
        c && (b.style.display = "none"),
        (b.select = a),
        (b.options = a.options),
        (b.selectedIndex = a.selectedIndex),
        (this.select = a),
        (this.replacement = b),
        a.onchange &&
          (b.onclick = function () {
            $(this.select).trigger("change");
          }),
        a.ondblclick &&
          (b.ondblclick = function () {
            $(this.select).trigger("dblclick");
          });
      for (var g = "<ul>", h = 0; h < a.childNodes.length; h++)
        a.childNodes[h].tagName &&
          3 != a.nodeType &&
          ("OPTGROUP" == a.childNodes[h].tagName
            ? (g += ISSelectReplacement.add_group(a, a.childNodes[h], h))
            : "OPTION" == a.childNodes[h].tagName &&
              (g += ISSelectReplacement.add_option(a, a.childNodes[h], h)));
      (g += "</ul>"),
        (b.innerHTML = g),
        a.parentNode.insertBefore(b, a),
        (a.style.display = "none");
    },
    get_prop: function (a, b) {
      var c;
      return a.currentStyle
        ? a.currentStyle[b]
        : document.defaultView &&
          document.defaultView.getComputedStyle &&
          (c = document.defaultView.getComputedStyle(a, ""))
        ? ((b = b.replace(/([A-Z])/g, "-$1")),
          (b = b.toLowerCase()),
          c.getPropertyValue(b))
        : void 0;
    },
    add_group: function (a, b, c) {
      var d = "";
      if (
        (b.className && (d = b.className),
        (group_html =
          '<li class="ISSelectGroup ' + d + '"><div>' + b.label + "</div>"),
        b.childNodes)
      ) {
        group_html += "<ul>";
        for (var e = 0; e < b.childNodes.length; e++)
          b.childNodes[e].tagName &&
            3 != b.childNodes[e].nodeType &&
            (group_html += ISSelectReplacement.add_option(a, b.childNodes[e], [
              c,
              e,
            ]));
        group_html += "</ul>";
      }
      return (group_html += "</li>"), group_html;
    },
    add_option: function (a, b, c) {
      var d,
        e = "";
      b.selected ? ((d = "SelectedRow"), (e = 'checked="checked"')) : (d = ""),
        b.className && (d += " " + b.className);
      var f = b.innerHTML,
        g = f.match(/^\s*(&nbsp;)*/);
      g[0] && (f = f.replace(/^\s*(&nbsp;)*/, ""));
      var h = "";
      if (this.select.disabled) var h = ' disabled="disabled"';
      var i = "",
        j = "";
      if (b.className && -1 != b.className.indexOf("forceKey")) {
        var k = b.className.indexOf("forceKey"),
          l = b.className.indexOf(" ", k + 1);
        if (-1 == l) var l = b.className.length;
        var i = b.className.substring(k + 8, l),
          j = "[]";
      }
      var m = "ISSelect" + a.name.replace("[]", "") + "_" + b.value;
      return (
        (html =
          '<li id="' +
          m +
          '" class="' +
          d +
          '" onselectstart="return false;" style="-moz-user-select: none;" onmouseover="ISSelectReplacement.on_hover(this, \'' +
          c +
          "', 'over');\"onmouseout=\"ISSelectReplacement.on_hover(this, '" +
          c +
          "', 'out');\" onclick=\"ISSelectReplacement.on_click(this, '" +
          c +
          "');\">" +
          g[0]),
        $(b).hasClass("freeform")
          ? (html +=
              '<input id="' +
              m +
              '_input" type="textbox" name="ISSelectReplacement_' +
              a.name +
              "[" +
              i +
              "]" +
              j +
              '" value="' +
              b.value +
              '" onclick="ISSelectReplacement.on_click(this, \'' +
              c +
              "');\" />")
          : (html +=
              '<input id="' +
              m +
              '_input" type="checkbox" name="ISSelectReplacement_' +
              a.name +
              "[" +
              i +
              "]" +
              j +
              '" value="' +
              b.value +
              '" ' +
              e +
              h +
              '" onclick="ISSelectReplacement.on_click(this, \'' +
              c +
              '\');" /><label for="' +
              m +
              '_input" onclick="ISSelectReplacement.on_click(this, \'' +
              c +
              "');\">" +
              f +
              "</label>"),
        (html += "</li>"),
        html
      );
    },
    on_hover: function (a, b, c) {
      var b = b.split(",");
      if (2 == b.length)
        var d = a.parentNode.parentNode.parentNode.parentNode.nextSibling,
          e = d.childNodes[b[0]].childNodes[b[1]];
      else
        var d = a.parentNode.parentNode.nextSibling,
          e = d.childNodes[b[0]];
      "out" == c
        ? ($(a).removeClass("ISSelectOptionHover"), $(e).trigger("mouseout"))
        : ($(a).hasClass("SelectedRow") || $(a).addClass("ISSelectOptionHover"),
          $(e).trigger("mouseover"));
    },
    scrollToItem: function (a, b, c) {
      var d = "ISSelect" + a.replace("[]", "") + "_" + b;
      if (document.getElementById(d)) {
        var e = document.getElementById(d),
          f = e.offsetTop - 4;
        for ("undefined" != typeof c && (f -= 20); e && "DIV" != e.tagName; )
          if (((e = e.parentNode), e && "DIV" == e.tagName)) {
            e.scrollTop = f;
            break;
          }
      }
    },
    on_click: function (a, b) {
      if (a.dblclicktimeout) return !1;
      if ("INPUT" == a.tagName || "LABEL" == a.tagName) {
        var c = a;
        if (c.disabled) return !1;
        var a = a.parentNode;
      } else {
        var c = a.getElementsByTagName("input")[0];
        if (c.disabled) return !1;
        c.checked = !c.checked;
      }
      a.dblclicktimeout = setTimeout(function () {
        a.dblclicktimeout = "";
      }, 250);
      var b = b.split(",");
      if (2 == b.length)
        var d = a.parentNode.parentNode.parentNode.parentNode.nextSibling,
          e = d.childNodes[b[0]].childNodes[b[1]];
      else
        var d = a.parentNode.parentNode.nextSibling,
          e = d.childNodes[b[0]];
      (e.selected = c.checked),
        ($(a).parents("div")[0].selectedIndex = d.selectedIndex),
        $(e).parents("select").trigger("change"),
        $(e).triggerHandler("click"),
        c.checked
          ? $(a).addClass("SelectedRow")
          : $(a).removeClass("SelectedRow");
    },
  };
  ISSelectReplacement.init();
}
!(function (a) {
  (a.belowthefold = function (b, c) {
    var d = a(window).height() + a(window).scrollTop();
    return d <= a(b).offset().top - c.threshold;
  }),
    (a.abovethetop = function (b, c) {
      var d = a(window).scrollTop();
      return d >= a(b).offset().top + a(b).height() - c.threshold;
    }),
    (a.rightofscreen = function (b, c) {
      var d = a(window).width() + a(window).scrollLeft();
      return d <= a(b).offset().left - c.threshold;
    }),
    (a.leftofscreen = function (b, c) {
      var d = a(window).scrollLeft();
      return d >= a(b).offset().left + a(b).width() - c.threshold;
    }),
    (a.inviewport = function (b, c) {
      return !(
        a.rightofscreen(b, c) ||
        a.leftofscreen(b, c) ||
        a.belowthefold(b, c) ||
        a.abovethetop(b, c)
      );
    }),
    a.extend(a.expr[":"], {
      "below-the-fold": function (b, c, d) {
        return a.belowthefold(b, { threshold: 0 });
      },
      "above-the-top": function (b, c, d) {
        return a.abovethetop(b, { threshold: 0 });
      },
      "left-of-screen": function (b, c, d) {
        return a.leftofscreen(b, { threshold: 0 });
      },
      "right-of-screen": function (b, c, d) {
        return a.rightofscreen(b, { threshold: 0 });
      },
      "in-viewport": function (b, c, d) {
        return a.inviewport(b, { threshold: 0 });
      },
    });
})(jQuery);
